export default {
  CANCEL: 1,
  OUTPUT: 2,
};
